// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"8":"56958dc3","280":"e618b00c","434":"67c560e6"}[chunkId] + ".css";
};